<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card :key="`${zone.id}`" class="mb-5">
      <v-data-table
        id="dnsRecords"
        :key="zone.id"
        :items="zoneRecords[zone.id]"
        :loading="loadingAvailable"
        :headers="headers"
        :items-per-page="100"
        :footer-props="{
          itemsPerPageOptions: [10, 50, 100, 250, -1],
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{ zone.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mb-2"
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  New Record</v-btn
                >
              </template>
              <v-card>
                <v-card-title>{{ formTitle }}</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4"
                        ><v-text-field
                          v-model="editedItem.name"
                          label="Record name"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6" md="4"
                        ><v-select
                          v-model="editedItem.type"
                          :items="recordTypes"
                          label="Type"
                        ></v-select
                      ></v-col>
                      <v-col cols="12" sm="6" md="4"
                        ><v-text-field
                          v-model="editedItem.ttl"
                          label="TTL"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6" md="4"
                        ><v-text-field
                          v-model="editedItem.priority"
                          label="Priority"
                          :disabled="editedItemPriorityDisabled"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6" md="4"
                        ><v-text-field
                          v-model="editedItem.content"
                          label="Content"
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6" md="4"
                        ><v-checkbox
                          v-model="editedItem.enabled"
                          label="Enabled"
                        ></v-checkbox
                      ></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.enabled="{ item }">
          <v-simple-checkbox
            v-model="item.enabled"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";

export default {
  mounted() {
    this.refreshRecords();
  },
  watch: {
    $route() {
      this.refreshRecords();
    },
    "$store.state.dns.dnsZoneNames"() {
      this.refreshRecords();
    },
  },
  data: () => ({
    index: 0,
    counter: 1,
    dialog: false,
    dialogDelete: false,
    zone: { name: "", id: "" },
    recordTypes: [
      "A",
      "AAAA",
      "CERT",
      "CNAME",
      "DNSKEY",
      "DS",
      "MX",
      "NAPTR",
      "NS",
      "PTR",
      "SPF",
      "SRV",
      "SSHFP",
      "TLSA",
      "TXT",
      "URI",
    ],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      content: "",
      type: "",
      ttl: 0,
      priority: 0,
      enabled: true,
    },
    defaultItem: {
      id: "",
      name: "",
      content: "",
      type: "A",
      ttl: 3600,
      priority: 0,
      enabled: true,
    },
    headers: [
      {
        text: "name",
        align: "start",
        sortable: true,
        value: "name",
        width: "20%",
      },
      {
        text: "record type",
        align: "start",
        sortable: true,
        value: "type",
        width: "12em",
      },
      {
        text: "content",
        align: "start",
        sortable: true,
        value: "content",
      },
      {
        text: "ttl",
        align: "start",
        sortable: true,
        value: "ttl",
        width: "10em",
      },
      {
        text: "priority",
        align: "start",
        sortable: true,
        value: "priority",
        width: "10em",
      },
      {
        text: "enabled",
        align: "start",
        sortable: true,
        value: "enabled",
        width: "10em",
      },
      {
        text: "actions",
        value: "actions",
        width: "10em",
      },
    ],
    errors: [],
    loadingAvailable: true,
    zoneRecords: {},
  }),

  methods: {
    refreshRecords() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      let zone_id = this.$route.params.zone_id;
      if (this.zoneRecords[zone_id] == undefined) {
        this.loadingAvailable = true;
      }
      this.zone = {
        id: zone_id,
        name: this.$store.getters.getDnsZoneNames[zone_id],
      };
      api
        .query(`/zones/${zone_id}/records`)
        .then((response) => {
          this.zoneRecords = {
            ...this.zoneRecords,
            [zone_id]: response.data.records.map((el) => ({
              ...el,
              enabled: !el.disabled,
            })),
          };
        })
        .catch((error) => (this.errors = [error]))
        .finally(() => {
          this.loadingAvailable = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.zoneRecords[this.zone.id].indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.zoneRecords[this.zone.id].indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      const zone_id = this.zone.id;
      const record_id = this.editedItem.id;
      api.delete(`/zones/${zone_id}/records/${record_id}`).then((response) => {
        const index = this.zoneRecords[zone_id].findIndex(
          (el) => el.id === record_id
        );
        if (index > -1) this.zoneRecords[zone_id].splice(index, 1);
      });
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.editedItemPriorityDisabled) {
        this.editedItem.priority = 0;
      }
      // Copy locally in case this changes before update/insert result
      const editedItem = Object.assign({}, this.editedItem);
      const zone_id = this.zone.id;
      let { id: record_id, enabled, ...values } = editedItem;
      values = { ...values, disabled: !enabled };

      if (this.editedIndex > -1) {
        api
          .patch(`/zones/${zone_id}/records/${record_id}`, values)
          .then((response) => {
            Object.assign(
              this.zoneRecords[zone_id].find(
                (val) => val.id == response.data.id
              ),
              { ...editedItem, ...response.data }
            );
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      } else {
        api
          .post(`/zones/${zone_id}/records`, values)
          .then((response) => {
            this.zoneRecords[zone_id].push({
              ...editedItem,
              ...response.data,
              enabled: !response.data.disabled,
            });
          })
          .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
      }
      this.close();
    },
  },
  computed: {
    _headers() {
      return this.headers.filter((x) => x.show);
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    editedItemPriorityDisabled() {
      return this.editedItem.type != "MX" && this.editedItem.type != "SRV";
    },
  },
};
</script>
<style lang="css">
#dnsRecords tr {
  word-break: break-all;
}
</style>
